/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import EventPageDetailStatsTicketSales from './ticketSales';
import EventPageDetailStatsTop5 from './top5';
import EventPageDetailStatsGuageCard from './guageChartCard';
import EventPageDetailStatsProgressCard from './progressCard';
import EventPageDetailStatsBreakdown from './breakdown';
import EventPageDetailStatsAcBreakdown from './atBreakdown';
import Loader from '/client/src/components/Loader';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { GET } from '/client/src/api';
import { mockData } from './mock';
import { currency } from '/client/src/constants/';

import './styles.scss';

type PropsType = {
  eventId: number | string
};

// TODO: disable all get request from api when no have a data (ticketsRevenueStatistics - false)

class EventPageDetailStats extends React.Component<PropsType> {
  props: PropsType;

  static contextType = EventDetailContainerContext;

  state = {
    tickets: null,
    donationsRevenueStatistics: null,
    ticketsRevenueStatistics: null,
    totalQuality: null
  };

  getTotalValueFromStats = (nameValue: string, data: []): void => {
    let res = 0;

    data.map((i: {}) => {
      res = res + i[`${nameValue}`];
    });

    return res;
  };
  getTotalPrice = (data: []): void => {
    let res = 0;

    data.map((i: {}) => res = res + i.stock_quantity * i.price);

    return res;
  };

  handleLoaded = async (error: Error, response: any) => {
    const { eventId } = this.props;

    if (!error) {
      this.setState({
        tickets: _.get(response, 'data.result', [])
      });

      const { result } = await GET(`/api/v1/1/statistics/events/${eventId}/transaction/tickets_and_donations`);

      this.setState({
        donationsRevenueStatistics: _.get(result, 'donations_revenue_statistics', []),
        ticketsRevenueStatistics: _.get(result, 'tickets_revenue_statistics', []),
        totalQuality: {
          sold_quantity: this.getTotalValueFromStats('sold_quantity', _.get(result, 'tickets_revenue_statistics', [])),
          return_quantity: this.getTotalValueFromStats('return_quantity', _.get(result, 'tickets_revenue_statistics', [])),
          merchant_revenue: this.getTotalValueFromStats('merchant_revenue', _.get(result, 'tickets_revenue_statistics', [])),
          merchant_revenue_refund: this.getTotalValueFromStats('merchant_revenue_refund', _.get(result, 'tickets_revenue_statistics', [])),
          stock_quantity: this.getTotalValueFromStats('stock_quantity', this.state.tickets),
          price: this.getTotalPrice(this.state.tickets)
        },
          currencySign: currency[_.get(result, 'tickets_revenue_statistics[0].currency', '') || 'USD']
      });
    }
  };

  render(): React.Element<'div'> {
    const  { eventId } = this.props;
    const { eventDetail } = this.context;
    const { ticketsRevenueStatistics, currencySign } = this.state;

    let { totalQuality } = this.state;

    if (!_.size(ticketsRevenueStatistics)) {// no statistic
      totalQuality = mockData.TicketTotalQuality;
    }

    const schedule = eventDetail ?
      _.find(eventDetail.schedules,
        (sch: {}): {} => _.toString(sch.event_id) === _.toString(eventId)) : {};

    const donationGoal = (): void => {
      const data = _.get(eventDetail, 'donations', []);

      let goal = 0;

      data.map((item: any): void => goal = goal + item.goal);

      return goal;
    };

    return (
      <Loader
        url={`/api/v1/1/events/${eventId}/tickets_all?scheduleId=${schedule.id}&paymentMethod=1`}
        onLoaded={this.handleLoaded}
      >
      <div id="chart-views" className="row EventPageDetailStats">
        {!_.isNull(ticketsRevenueStatistics) ?
          <>
            {!_.size(ticketsRevenueStatistics) &&
              <div className="col-lg-12">
                <div
                  className="alert alert-warning text-center"
                  style={{
                    padding:'10px',
                    background:'#F7F892',
                    borderColor: '#F7F892',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#000',
                    overflow:'hidden' }}
                >
                  We don't have any data just yet. Here's how it might look...
                </div>
              </div>
            }

            {/* row start */}
            <div className="row">
              <div className="col-lg-8">
                <EventPageDetailStatsTicketSales
                  isNoStatistic={!_.size(ticketsRevenueStatistics)}
                  {...this.state}
                  {...this.props}
                />
              </div>

              <div className="col-lg-4">
                <EventPageDetailStatsGuageCard
                  header='Ticket and Financial Summary'
                  currencySign={currencySign}
                  chart1={{
                    title: 'Current tickets sold',
                    value: totalQuality.sold_quantity - totalQuality.return_quantity || 0,
                    total: totalQuality.stock_quantity
                  }}
                  chart2={{
                    title: 'Current payout',
                    value: (totalQuality.merchant_revenue - totalQuality.merchant_revenue_refund) / 100  || 0,
                    total: totalQuality.price / 100
                  }}
                />
              </div>
            </div>
            {/* row end */}

            {/* row start */}
            <div className="row">
              <div className="col-lg-8">
                 <EventPageDetailStatsTop5
                   isNoStatistic={!_.size(ticketsRevenueStatistics)}
                   {...this.props}
                 />
              </div>

              <div className="col-lg-4">
                <EventPageDetailStatsGuageCard
                  header='Refund Overview'
                  currencySign={currencySign}
                  chart1={{
                    title: 'Ticket Volume Refunded',
                    value: totalQuality.return_quantity || 0,
                    total: totalQuality.sold_quantity || 100
                  }}
                  chart2={{
                    title: 'Gross Refunds Issued',
                    value: totalQuality.merchant_revenue_refund / 100 || 0,
                    total: totalQuality.merchant_revenue / 100 || 100
                  }}
                  {...this.props}
                />
              </div>
            </div>
            {/* row end */}

            {/* row start */}
            <div className="row">
              <div className="col-lg-4">
                <EventPageDetailStatsProgressCard
                  isNoStatistic={!_.size(ticketsRevenueStatistics)}
                  header='Ticket Breakdown'
                  color='green'
                  {...this.state}
                  ticketBreak
                />
              </div>

              <div className="col-lg-4">
                 <EventPageDetailStatsProgressCard
                   isNoStatistic={!_.size(ticketsRevenueStatistics)}
                   header='Donation Breakdown'
                   color='blue'
                   donationGoal={donationGoal()}
                   {...this.state}
                 />
              </div>

              <div className="col-lg-4">
                <EventPageDetailStatsBreakdown
                  isNoStatistic={!_.size(ticketsRevenueStatistics)}
                  {...this.props}
                  ticketsRevenueStatistics={this.state.ticketsRevenueStatistics}
                />
                <EventPageDetailStatsAcBreakdown {...this.props} />
              </div>
            </div>
            {/* row end */}
          </> :
          <div
            className="csspinner"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }}
          />
        }

      </div>
      </Loader>
    );
  }
}

export default EventPageDetailStats;
